import aeroConfig from './aeroswap';
import changeHeroConfig from './change-hero';
import changeNowConfig from './change-now';
import changellyConfig from './changelly';
import cicConfig from './cic';
import exolitConfig from './exolit';
import nexchangeConfig from './nexchange';
import switchainConfig from './switchain';
import { areAmountsValid } from '../../../utils';
const providers = {
    ...aeroConfig,
    ...changeHeroConfig,
    ...changeNowConfig,
    ...changellyConfig,
    ...cicConfig,
    ...exolitConfig,
    ...nexchangeConfig,
    ...switchainConfig,
};
const checkOrderIsValidWithProvider = async ({ providerOrder, order, fetchival, }) => {
    const getProviderOrder = providers[providerOrder.provider.slug];
    if (!getProviderOrder) {
        throw new Error(`Unknown verifier for ${providerOrder.provider.slug}`);
    }
    const orderFromProvider = await getProviderOrder(providerOrder, fetchival);
    const amountsValid = areAmountsValid(String(order.amount.value), orderFromProvider.depositAmount);
    if (!amountsValid) {
        throw new Error(`Invalid Order: ${order.amount.value} !== ${orderFromProvider.depositAmount}`);
    }
    if (order.providerOrderId !== orderFromProvider.orderId) {
        throw new Error(`Invalid Order: ${order.providerOrderId} !== ${orderFromProvider.orderId}`);
    }
    if (order.payInAddress !== orderFromProvider.depositAddress) {
        throw new Error(`Invalid Order: ${order.payInAddress} !== ${orderFromProvider.depositAddress}`);
    }
    if (order.toAddress !== orderFromProvider.withdrawalAddress) {
        throw new Error(`Invalid Order: ${order.toAddress} !== ${orderFromProvider.withdrawalAddress}`);
    }
};
export default checkOrderIsValidWithProvider;
